import React, { useState, useEffect, useContext, useRef } from 'react';
import moment from 'moment';
import '../../css/Table.css';
import { AlertContext } from '../../AlertContext';

const EnquiryList = ({ apiUrl }) => {
  const { showAlert } = useContext(AlertContext);

  const [enquiries, setEnquiries] = useState([]);
  const [sortOrder, setSortOrder] = useState('');
  const [selectedEnquiries, setSelectedEnquiries] = useState([]);

  const fetchEnquiries = async () => {
    try {
      const response = await fetch(`${apiUrl}/dashboard/customer/enquiry`);
      const data = await response.json();
      setEnquiries(data);
      if (response.status === 201) {
        showAlert('Fetched Enquiries Successfully', 'success');
      } else {
        showAlert('Error in fetching Enquiries', 'danger');
      }
    } catch (error) {
      console.error('Error fetching enquiries:', error);
    }
  };

  const fetchEnquiriesRef = useRef(fetchEnquiries);

  useEffect(() => {
    fetchEnquiriesRef.current();
  }, []);

  const handleSort = () => {
    if (sortOrder === 'asc') {
      const sortedEnquiries = enquiries.slice().sort((a, b) => moment(a.createdAt).toDate() - moment(b.createdAt).toDate());
      setEnquiries(sortedEnquiries);
      setSortOrder('desc');
    } else {
      const sortedEnquiries = enquiries.slice().sort((a, b) => moment(b.createdAt).toDate() - moment(a.createdAt).toDate());
      setEnquiries(sortedEnquiries);
      setSortOrder('asc');
    }
  };

  const handleSelectEnquiry = (enquiry) => {
    const isSelected = selectedEnquiries.includes(enquiry);

    if (isSelected) {
      setSelectedEnquiries(selectedEnquiries.filter((e) => e !== enquiry));
    } else {
      setSelectedEnquiries([...selectedEnquiries, enquiry]);
    }
  };

  const handleDeleteSelectedEnquiries = async () => {
    try {
      const response = await fetch(`${apiUrl}/dashboard/customer/enquiry`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ selectedEnquiries }),
      });

      if (response.ok) {
        // Refetch the updated enquiries
        fetchEnquiries();
        setSelectedEnquiries([]);
      } else {
        showAlert('Error deleting selected Enquiries', 'danger');
      }
    } catch (error) {
      console.error('Error deleting enquiries:', error);
    }
  };
  // Add the new enquiry to the list on component mount

  return (
    <div className="container">
      <h3>Enquiry List:</h3>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Select</th>
              <th>Id</th>
              <th>Customer Name</th>
              <th>Phone Number</th>
              <th>Enquiry</th>
              <th>Address</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {enquiries.map((enquiry, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedEnquiries.includes(enquiry)}
                    onChange={() => handleSelectEnquiry(enquiry)}
                  />
                </td>
                <td>{index + 1}</td>
                <td>{enquiry.name}</td>
                <td>{enquiry.phoneNumber}</td>
                <td>{enquiry.enquiry}</td>
                <td>{enquiry.address}</td>
                <td>{moment(enquiry.createdAt).format('DD-MM-YYYY')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        {selectedEnquiries.map((enquiry)=>(
          <li className='form-field' key={enquiry.name}>
          <strong>Name:</strong> {enquiry.name} 
        </li>
        ))}
      </div>
      <div className='d-flex justify-content-around'>
        <button disabled={selectedEnquiries.length===0} type='submit' onClick={handleDeleteSelectedEnquiries} className="btn btn-danger">
          Delete Selected Enquiries
        </button>
        <button onClick={handleSort} className="btn btn-sm btn-primary">
          Sort by Date {sortOrder === 'asc' ? <span>&#9650;</span> : <span>&#9660;</span>}
        </button>
      </div>
    </div>
  );
};

export default EnquiryList;
